import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c950504"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-range" }
const _hoisted_2 = { class: "filter-range__values-wrap" }
const _hoisted_3 = { class: "filter-range__value" }
const _hoisted_4 = { class: "filter-range__value" }

import FilterDropdown from './FilterDropdown.vue';
import FilterRange from './FilterRange.vue';
import { TNumberFields } from '@/services';
import { parseCamelCase, isNumber } from '@/utils';
import { useFilterByRange } from '@/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterByRange',
  props: {
    keyOfProduct: null
  },
  setup(__props: any) {

const props = __props as {
  keyOfProduct: keyof TNumberFields,
};




const { maxTotal, bounds, minTotal, applyBounds } = useFilterByRange(props.keyOfProduct);

function validateBounds(value?: number) {
  return isNumber(value) && 
         value !== Number.POSITIVE_INFINITY && 
         value !== Number.NEGATIVE_INFINITY ? 
         Math.round(value * 100) / 100 : 
         '--';
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FilterDropdown, {
    title: _unref(parseCamelCase)(__props.keyOfProduct)
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createVNode(FilterRange, {
          left: _unref(bounds).lower,
          "onUpdate:left": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bounds).lower) = $event)),
          right: _unref(bounds).upper,
          "onUpdate:right": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bounds).upper) = $event)),
          max: _unref(maxTotal),
          min: _unref(minTotal),
          onRelease: _unref(applyBounds)
        }, null, 8 /* PROPS */, ["left", "right", "max", "min", "onRelease"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(validateBounds(_unref(bounds).lower)), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_4, _toDisplayString(validateBounds(_unref(bounds).upper)), 1 /* TEXT */)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title"]))
}
}

})